import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocalizeMessage, useToastNotification } from 'libs.nucleus';
const mapNotifications = ({ notification, additionalSubtitleText, }) => (_jsxs("div", { children: [additionalSubtitleText && (_jsxs(_Fragment, { children: [_jsx("p", { children: additionalSubtitleText }), _jsx("br", {})] })), Object.entries(notification).map(([notificationName, notificationData]) => (_jsx("div", { children: _jsxs("span", { children: [notificationName || '', ": ", notificationData.locales.join(', ')] }) }, notificationName)))] }));
export const useAddLocalizationImportNotification = () => {
    const { addNotification } = useToastNotification();
    const translate = useLocalizeMessage();
    const handleAddNotification = (data, hasError = false) => {
        if (!data.length && hasError) {
            return;
        }
        if (!data) {
            addNotification({
                title: translate(`Locales imported successfully`),
                type: 'success',
            });
            return;
        }
        const successNotification = {};
        const warningNotification = {};
        const addLocaleToNotification = (notification, assetName, locale) => {
            var _a;
            const existingLocales = ((_a = notification[assetName]) === null || _a === void 0 ? void 0 : _a.locales) || [];
            notification[assetName] = {
                locales: [...existingLocales, locale],
            };
        };
        for (const { locale, contentNotChanged, displayName } of data) {
            if (contentNotChanged) {
                addLocaleToNotification(warningNotification, displayName, locale);
            }
            else {
                addLocaleToNotification(successNotification, displayName, locale);
            }
        }
        const hasSuccessNotification = Object.entries(successNotification).length > 0;
        const hasWarningNotification = Object.entries(warningNotification).length > 0;
        if (hasSuccessNotification || hasWarningNotification) {
            if (hasSuccessNotification) {
                addNotification({
                    title: translate(`Locales imported successfully`),
                    subtitle: hasWarningNotification || hasError ? mapNotifications({ notification: successNotification }) : undefined,
                    type: 'success',
                    timeout: 30000,
                });
            }
            if (hasWarningNotification) {
                addNotification({
                    title: translate(`No modifications detected`),
                    subtitle: mapNotifications({
                        notification: warningNotification,
                        additionalSubtitleText: translate('The following files did not include any changes, and remain unmodified in the system.'),
                    }),
                    type: 'warning',
                    timeout: 30000,
                });
            }
        }
        else {
            addNotification({
                title: translate(`Locales imported successfully`),
                type: 'success',
            });
        }
    };
    return {
        handleAddNotification,
    };
};
//# sourceMappingURL=use_add_localization_import_notification.hook.js.map